var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Button, Grid, Typography } from "@material-ui/core";
import { SpaciousTypography } from "./styleComponents";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import MarkdownText from "./MarkdownText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
var ChoicesContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 7;\n"], ["\n  padding-top: 7;\n"])));
var DisabledButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  text-transform: none;\n  margin: 0.5em 0;\n  border-radius: 15px;\n  border: 1px solid rgba(0, 0, 0, 0.23);\n  padding: 15px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n  background-color: rgba(0, 0, 0, 0) !important;\n"], ["\n  ", "\n  text-transform: none;\n  margin: 0.5em 0;\n  border-radius: 15px;\n  border: 1px solid rgba(0, 0, 0, 0.23);\n  padding: 15px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n  background-color: rgba(0, 0, 0, 0) !important;\n"])), function (_a) {
  var onlyOneItem = _a.onlyOneItem;
  return onlyOneItem && "width: 70%;";
});
var ChoiceButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n\n  text-transform: none;\n  margin: 0.5em 0;\n  border-radius: 15px;\n  border: 1px solid\n    ", ";\n  padding: 15px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n"], ["\n  ", "\n\n  text-transform: none;\n  margin: 0.5em 0;\n  border-radius: 15px;\n  border: 1px solid\n    ", ";\n  padding: 15px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);\n"])), function (_a) {
  var onlyOneItem = _a.onlyOneItem,
      selected = _a.selected;
  return (onlyOneItem ? "width: 70%" : "") + ";\n  " + (!selected ? "background-color: white;" : "");
}, function (_a) {
  var selected = _a.selected;
  return selected ? "rgba(0, 0, 0, 0)" : "rgba(0, 0, 0, 0.23)";
});
var CentralizedOnSmallScreenTypography = styled(Typography)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  @media only screen and (max-width: 600px) {\n    text-align: center;\n  }\n"], ["\n  @media only screen and (max-width: 600px) {\n    text-align: center;\n  }\n"])));
var IconWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0.5rem;\n"], ["\n  margin: 0.5rem;\n"])));

var SuccessIcon = function SuccessIcon() {
  return React.createElement(IconWrapper, null, React.createElement(FontAwesomeIcon, {
    icon: faCheck
  }));
};

var FailureIcon = function FailureIcon() {
  return React.createElement(IconWrapper, null, React.createElement(FontAwesomeIcon, {
    icon: faTimes
  }));
};

var AttentionIcon = styled(FontAwesomeIcon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-size: 30px !important;\n"], ["\n  font-size: 30px !important;\n"])));
var RevealedChoiceButton = styled(function (_a) {
  var selected = _a.selected,
      correct = _a.correct,
      others = __rest(_a, ["selected", "correct"]);

  return React.createElement(ChoiceButton, __assign({
    variant: "contained"
  }, others), selected ? correct ? React.createElement(SuccessIcon, null) : React.createElement(FailureIcon, null) : "", others.children);
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
  return props.selected ? "\n    color: white;\n    background-color: " + (props.correct ? "#047500" : "#DB0000") + ";\n    " : props.correct ? "\n    color: #047500;\n    border-color: #047500;\n    border-width: 3px\n    " : "";
});
var BottomMarginedGrid = styled(Grid)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  margin-bottom: 10px;\n"], ["\n  margin-bottom: 10px;\n"])));
var LeftBorderedDiv = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  border-left: 6px solid ", ";\n  box-sizing: border-box;\n  padding: 3px;\n  padding-left: 10px;\n  margin-bottom: 5px !important;\n  ", "\n"], ["\n  border-left: 6px solid ", ";\n  box-sizing: border-box;\n  padding: 3px;\n  padding-left: 10px;\n  margin-bottom: 5px !important;\n  ", "\n"])), function (_a) {
  var barColor = _a.barColor;
  return barColor;
}, function (onlyOneItem) {
  return onlyOneItem && "width: 70%;";
});
var SolutionDiv = styled(function (correct) {
  var others = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    others[_i - 1] = arguments[_i];
  }

  return React.createElement(LeftBorderedDiv, __assign({
    barColor: correct ? "#047500" : "#DB0000"
  }, others));
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));

var MultipleChoice = function MultipleChoice(_a) {
  var item = _a.item;
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var answer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });

  if (!quiz) {
    return React.createElement("div", null);
  }

  var itemAnswer = answer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });

  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }

  var onlyOneItem = quiz.items.length === 1;
  var options = item.options;
  var direction = "row";
  var alignItems = "baseline";
  var questionWidth = 6;
  var optionContainerWidth = 6;
  var optionWidth = "auto";

  if (onlyOneItem) {
    var maxOptionLength = Math.max.apply(Math, options.map(function (option) {
      return option.texts[0].title.length;
    }));
    var width = maxOptionLength > 100 ? 12 : Math.ceil(maxOptionLength / (8 + 1 / 3));
    optionContainerWidth = 12;
    optionWidth = 12;
    questionWidth = 12;
    direction = "column";
    alignItems = "center";
  }

  return React.createElement(BottomMarginedGrid, {
    container: true,
    direction: direction,
    alignItems: alignItems
  }, React.createElement(ItemInformation, {
    item: item,
    itemAnswer: itemAnswer,
    onlyOneItem: onlyOneItem,
    questionWidth: questionWidth
  }), React.createElement(ChoicesContainer, {
    item: true,
    container: true,
    justify: "space-evenly",
    xs: optionContainerWidth
  }, options.sort(function (o1, o2) {
    return o1.order - o2.order;
  }).map(function (option, index) {
    return React.createElement(Option, {
      key: option.id,
      option: option,
      optionWidth: optionWidth,
      shouldBeGray: index % 2 === 0
    });
  })), !onlyOneItem && React.createElement(FeedbackPortion, {
    item: item
  }));
};

var ItemInformation = function ItemInformation(_a) {
  var questionWidth = _a.questionWidth,
      onlyOneItem = _a.onlyOneItem,
      item = _a.item,
      itemAnswer = _a.itemAnswer;
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var displayFeedback = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });

  if (!languageInfo) {
    return React.createElement("div", null);
  }

  var multipleChoiceLabels = languageInfo.multipleChoice;
  var selectOptionsLabel = answerLocked ? "" : item.multi ? multipleChoiceLabels.chooseAllSuitableOptionsLabel : onlyOneItem ? multipleChoiceLabels.selectCorrectAnswerLabel : "";
  var _b = item.texts[0],
      title = _b.title,
      body = _b.body,
      successMessage = _b.successMessage,
      failureMessage = _b.failureMessage;
  return React.createElement(ItemInformationGridItem, {
    item: true,
    xs: questionWidth
  }, title && React.createElement(MarkdownText, {
    Component: SpaciousTypography,
    removeParagraphs: true,
    variant: "subtitle1"
  }, title), body && React.createElement(MarkdownText, null, body), selectOptionsLabel && React.createElement(SelectOptionsLabelTypography, {
    variant: "subtitle1"
  }, selectOptionsLabel));
};

var ItemInformationGridItem = styled(Grid)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var SelectOptionsLabelTypography = styled(Typography)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  color: 6b6b6b;\n"], ["\n  color: 6b6b6b;\n"])));

var Option = function Option(_a) {
  var option = _a.option,
      optionWidth = _a.optionWidth,
      shouldBeGray = _a.shouldBeGray;
  var dispatch = useDispatch();
  var items = useTypedSelector(function (state) {
    return state.quiz.items;
  });
  var item = items.find(function (i) {
    return i.id === option.quizItemId;
  });
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var displayFeedback = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });

  if (!item || !languageLabels) {
    return React.createElement("div", null, "Cannot find related item or language");
  }

  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  var onlyOneItem = items.length === 1;
  var text = option.texts[0];

  if (!itemAnswer && !quizDisabled) {
    return React.createElement("div", null, "Answer cannot be retrieved");
  }

  var handleOptionChange = function handleOptionChange(optionId) {
    return function () {
      return dispatch(quizAnswerActions.changeChosenOption(item.id, optionId));
    };
  };

  var optionAnswers = itemAnswer && itemAnswer.optionAnswers;
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var optionIsSelected = optionAnswers && optionAnswers.some(function (oa) {
    return oa.quizOptionId === option.id;
  });
  var generalLabels = languageLabels.general;
  var successMessage = text.successMessage || generalLabels.answerCorrectLabel;
  var failureMessage = text.failureMessage || generalLabels.answerIncorrectLabel;
  var feedbackMessage = option.correct === optionIsSelected ? successMessage : failureMessage;
  var feedbackColor = optionIsSelected ? option.correct ? "#047500" : "#DB0000" : "white";
  var properButton = quizDisabled ? React.createElement(DisabledButton, {
    onlyOneItem: onlyOneItem,
    variant: "contained",
    fullWidth: true,
    disabled: true
  }, React.createElement(MarkdownText, {
    Component: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""]))),
    removeParagraphs: true
  }, text.title)) : React.createElement(ChoiceButton, {
    onlyOneItem: onlyOneItem,
    selected: !!optionIsSelected,
    variant: "contained",
    fullWidth: true,
    color: optionIsSelected ? "primary" : "default",
    onClick: handleOptionChange(option.id)
  }, React.createElement(MarkdownText, {
    Component: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject([""], [""]))),
    removeParagraphs: true
  }, text.title));

  if (!displayFeedback) {
    return React.createElement(OptionGridItem, {
      item: true,
      xs: optionWidth,
      onlyOneItem: onlyOneItem,
      shouldBeGray: shouldBeGray
    }, properButton);
  }

  var clickOptions = answerLocked ? {} : {
    onClick: handleOptionChange(option.id)
  };

  if (onlyOneItem) {
    return React.createElement(React.Fragment, null, React.createElement(OptionGridItem, {
      item: true,
      xs: optionWidth,
      onlyOneItem: onlyOneItem,
      shouldBeGray: shouldBeGray
    }, React.createElement(RevealedChoiceButton, __assign({
      onlyOneItem: onlyOneItem,
      selected: optionIsSelected,
      correct: option.correct
    }, clickOptions, {
      fullWidth: true
    }), React.createElement(MarkdownText, {
      Component: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject([""], [""]))),
      removeParagraphs: true
    }, text.title))), optionIsSelected && React.createElement(OptionGridItem, {
      item: true,
      xs: optionWidth,
      onlyOneItem: onlyOneItem,
      shouldBeGray: shouldBeGray
    }, React.createElement(FeedbackPortion, {
      item: item,
      selectedOption: option
    })));
  }

  return React.createElement(React.Fragment, null, React.createElement(OptionGridItem, {
    item: true,
    xs: optionWidth,
    onlyOneItem: onlyOneItem,
    shouldBeGray: shouldBeGray
  }, React.createElement(RevealedChoiceButton, __assign({
    onlyOneItem: onlyOneItem,
    selected: optionIsSelected,
    correct: option.correct
  }, clickOptions, {
    fullWidth: true
  }), React.createElement(MarkdownText, {
    Component: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject([""], [""]))),
    removeParagraphs: true
  }, text.title))));
};

var FeedbackPortion = function FeedbackPortion(_a) {
  var item = _a.item,
      selectedOption = _a.selectedOption;
  var items = useTypedSelector(function (state) {
    return state.quiz.items;
  });
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var feedbackDisplayed = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });

  if (!feedbackDisplayed) {
    return React.createElement("div", {
      style: {
        display: "none"
      }
    });
  }

  if (!item || !languageLabels) {
    return React.createElement("div", null, "Cannot find related item or language");
  }

  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });

  if (!itemAnswer) {
    return React.createElement("div", null, "Cannot find related item answer");
  }

  var onlyOneItem = items.length === 1;
  var generalLabels = languageLabels.general;
  var feedbackMessage;

  if (item.usesSharedOptionFeedbackMessage && item.texts[0].sharedOptionFeedbackMessage !== undefined) {
    feedbackMessage = item.texts[0].sharedOptionFeedbackMessage;
  } else {
    var optionSuccess = selectedOption ? selectedOption.texts[0].successMessage : undefined;
    var optionFailure = selectedOption ? selectedOption.texts[0].failureMessage : undefined;
    var text = item.texts[0];
    var successMessage = optionSuccess || text.successMessage || generalLabels.answerCorrectLabel;
    var failureMessage = optionFailure || text.failureMessage || generalLabels.answerIncorrectLabel;
    feedbackMessage = itemAnswer.correct ? successMessage : failureMessage;
  }

  var feedbackColor = itemAnswer.correct ? "#047500" : "#DB0000";
  return React.createElement(LeftBorderedDiv, {
    barColor: feedbackColor,
    onlyOneItem: onlyOneItem
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: "auto"
  }, React.createElement(CentralizedOnSmallScreenTypography, {
    variant: "body1"
  }, React.createElement(AttentionIcon, {
    icon: faExclamationCircle
  }))), React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 10
  }, React.createElement(CentralizedOnSmallScreenTypography, {
    variant: "body1"
  }, feedbackMessage))));
};

var OptionGridItem = styled(Grid)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var onlyOneItem = _a.onlyOneItem,
      shouldBeGray = _a.shouldBeGray;
  return onlyOneItem ? "\n      display: flex;\n      justify-content: center;\n      background-color: " + (shouldBeGray ? "#605c980d" : "inherit") + ";\n    " : "";
});
export default MultipleChoice;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;